import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { SecurityLayerService } from 'src/app/___LOGIC/__auth/security-layer.service';
import { TranslationService } from 'src/app/___LOGIC/___common/__language/translation.service';
import { EmailService } from 'src/app/___LOGIC/__email/email.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

horizontalPosition: MatSnackBarHorizontalPosition = 'start';
verticalPosition: MatSnackBarVerticalPosition = 'top';
testing = environment.testingMode;

signin: FormGroup = new FormGroup({
  email: new FormControl(
    this.testing ? this.emailService.getAdminEmail() : '', // <-- fallback for non-testing
    [Validators.email, Validators.required]
  ),
  password: new FormControl(this.testing ? '1234' : '',[Validators.required, Validators.minLength(3)] ),
  username: new FormControl(this.testing ? this.emailService.getAdminEmail() : '',[Validators.required])
});


  get emailInput() { return this.signin.get('email'); }
  get passwordInput() { return this.signin.get('password'); }
  get usernameInput() { return this.signin.get('username'); }

  hide = true;
  termsAndConditions = false;

  email: string = '';
  password: string = '';
  loginObj = {
    path: '',
    username: '', 
    token: ''
  };

  // Toledo Foto
  //Photo by <a href="https://unsplash.com/@schoelderle?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Greta Schölderle Möller</a> on <a href="https://unsplash.com/photos/aerial-photography-of-buildings-FOc1dAPuCIU?utm_content=creditCopyText&utm_medium=referral&utm_source=unsplash">Unsplash</a>
  
  constructor(private securityLayer: SecurityLayerService,private translationService: TranslationService,private emailService: EmailService) {
  }

  ngOnInit(): void {
    // Check if user is already logged in via cookies
    if(this.securityLayer.checkForCookies('login-webapp')){
      this.loginObj.path = 'cookiesAppLogin';
      this.loginObj.username = this.securityLayer.getCookie('voyjaleasSessionUsername').toLowerCase();
      this.loginObj.token = this.securityLayer.getCookie('voyjaleasSessionToken') != "undefined"? this.securityLayer.getCookie('voyjaleasSessionToken') : null;
      this.securityLayer.tryLogin(this.loginObj);
    }
  }
  
  login(): void {
    let loginObj = {
      path: 'login-webapp',
      username: this.usernameInput.value,
      password: this.passwordInput.value
    };
    this.securityLayer.tryLogin(loginObj);
  }

  onKeyUp(event: KeyboardEvent){
    if (event.key && event.key === "Enter") {
      this.login();
    }
  }

  isLoading(){
    return this.securityLayer.isLoginManagerLoading();
  }

  areFieldsFilled(){
    return this.usernameInput.value && this.passwordInput.value;
  }

  getTranslationFor(label){
    return this.translationService.getTranslatedText(label);
  }
}
